import T from "./ScsDictSelectTag.vue";
var ScsDictSelectTag = {
  install: function install(Vue) {
    Vue.component('ScsDictSelectTag', T);
  }
};
export default ScsDictSelectTag;